import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { PainSection } from '../components/PainSection';
import { WhyItHappensSection } from '../components/WhyItHappensSection';
import { SolutionSection } from '../components/SolutionSection';
import { WhatIncludedSection } from '../components/WhatIncludedSection';
import { BonusSection } from '../components/BonusSection';
import { ObjectionsSection } from '../components/ObjectionsSection';
import { FAQSection } from '../components/FAQSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FinalCTASection } from '../components/FinalCTASection';
import { Footer } from '../components/Footer';
import { useMetaPixel } from '../hooks/useMetaPixel';
export function LandingPage() {
  useMetaPixel();
  return <main className="min-h-screen w-full bg-white" data-id="element-375">
      <HeroSection data-id="element-376" />
      <PainSection data-id="element-377" />
      <WhyItHappensSection data-id="element-378" />
      <SolutionSection data-id="element-379" />
      <WhatIncludedSection data-id="element-380" />
      <BonusSection data-id="element-381" />
      <ObjectionsSection data-id="element-382" />
      <FinalCTASection data-id="element-383" />
      <GuaranteeSection data-id="element-384" />
      <FAQSection data-id="element-385" />
      <Footer data-id="element-386" />
    </main>;
}